'use strict';

export const Constants = Object.freeze({
  TOTAL_FEASIBILITY: 'Tot Feasibility',
  FEASIBILITY: 'Feasibility',
  TOTAL_COMPLETES: 'Tot Completes',
  COMPLETES: 'Completes',
  CPI: 'CPI',
  AVERAGE_CPI: 'Avg CPI',
  CREATE_SURVEY_REGEX_LINKS: [
    /\/create-surveys$/,
    /\/surveys\/\d{1,9}\/edit.*$/,
    /\/launch-survey\/\d{1,9}/,
    /\/recontact-survey.*$/,
  ],
  SHOW_SURVEY_REGEX_LINKS: [/\/dashboard$/, /\/dashboard\/\d{1,9}$/],
  SHOW_ASSIGN_PROJECT_MANAGER_TAB: /\/dashboard\/\d{1,9}$/,
  USER_ACCESS: {
    LINKS: {
      adjustments: '/buyer/adjustments',
      downloadReports: '/download-reports',
      invoiceOperations: '/invoice-operations',
      manageBuyerSettings: '/buyer/manage-buyer-settings',
      manageCompanies: '/manage-companies',
      manageSuppliers: '/buyer/manage-suppliers',
      manageUsers: '/manage-users',
      manageBuyers: '/manage-buyers',
      ManageSupplierPricingCard: '/supplier-pricing-card',
      ManageSupplierSettings: '/supplier-settings',
      operatorSettings: '/operator-settings',
      reportsDashboard: '/operator/reports-dashboard',
      selectServiceAccount: '#',
      questionLibrary: '/questions-library',
    },
    IGNORE_FEATURE_KEYS: [
      'CreateSurveys',
      'manageSurveys',
      'ManualSurveyTrafficFixes',
      'reconcile',
      'addAdvQuestion',
    ],
  },
  SUBSTRING_VALUE: 40,
  GLOBAL_OVERRIDE: 'global',
  SELECTIVE_OVERRIDE: 'manual',
  MCQBGLABAL: 'mcqbglobal',
  ADVANCE_FEASIBILITY: {
    FEASIBILITY_TYPE: {
      INCLUDE: 'Include',
      EXCLUDE: 'Exclude',
    },
    DATE_PICKER: {
      LOCALE: {
        format: 'MMMM D, YYYY',
        cancelLabel: 'Clear',
        applyLabel: 'Confirm',
      },
      MIN_YEAR: 2000,
      MAX_YEAR: 2035,
    },
  },
  DEFAULT_INCOME_VALUES: {
    from: 0,
    to: 9999999,
    prefix: '$',
  },
  MAGIC_NUMBERS: {
    ZERO: 0,
    TEN: 10,
    HUNDRED: 100,
  },
});
